const pageType =
  window.ShopifyAnalytics &&
  window.ShopifyAnalytics.meta &&
  window.ShopifyAnalytics.meta.page &&
  window.ShopifyAnalytics.meta.page.pageType;


const fixSnizeListProducts = ()=>{
   const resultItems = document.querySelectorAll(`.snize-product`);
    if (resultItems.length) {
      resultItems.forEach((resultItem) => {
        const productId = resultItem.getAttribute("id");
        if (productId) {
          const match = productId.match(/\d+$/);
          if (match) {
            const productId = match[0];
            const searchProductPrice = resultItem.querySelector(".snize-price");
            searchProductPrice.setAttribute("bss-b2b-product-id", productId);
            searchProductPrice.setAttribute("bss-b2b-product-price", "");
          }
        }
      });
    }
}
const fixSearchBar = () => {
  let timeout;
  const targetNode = document.querySelector(".search-flydown");
  const config = { attributes: true };
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === "attributes") {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          fixSnizeListProducts();
        }, 1000);
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
};
const fixCollection = () => {
  let counter = 0;
  let selector = ".snize-search-results-content .snize-price"
  const interval = setInterval(() => {
      if (document.querySelector(selector)) {
        clearInterval(interval);
        fixSnizeListProducts();
      } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100);
};
document.addEventListener("DOMContentLoaded", (event) => {
  if (BSS_B2B) {
    setTimeout(() => {
      const quickViews = document.querySelectorAll(".modal");
        quickViews.forEach((quickView) => {
          const mutationObserver = new MutationObserver(
            (recordList, observe) => {
               document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
            }
          );
          mutationObserver.observe(quickView, { attributes: true });
        });
    }, 5000);
    // compatible with snize
    // Search bar
    fixSearchBar();
    fixCollection();
  }
});
